import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { RegistrationEmployeeRole } from '@gipi-registration/employee-role/models/employee-roles.model';
import { RegistrationEmployeeRoleService } from '@gipi-registration/employee-role/services/employee-role.service';
import { OptionActiveSituation, OptionActiveSituationEnum } from '@gipi-shared/enums/option-active-situation.enum';
import { APP_MESSAGES, GIPIAbstractComponent, GIPIBaseService, INJECTOR, ObjectUtil, StringUtil } from '@gipisistemas/ng-core';

export interface EmployeeRolesFormData {
    typeOperation: 'NEW' | 'EDIT' | 'VIEW';
    employeeRole: RegistrationEmployeeRole;
}

@Component({
    templateUrl: './employee-roles-form-dialog.component.html',
    styles: [`
        :host {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
    `]
})
export class EmployeeRolesFormDialogComponent extends GIPIAbstractComponent implements OnInit, OnDestroy {

    public typeOperation: 'NEW' | 'EDIT' | 'VIEW' = 'NEW';

    public employeeRole: RegistrationEmployeeRole = new RegistrationEmployeeRole();

    public optionActiveSituationEnum: typeof OptionActiveSituationEnum = OptionActiveSituationEnum;
    public optionActiveSituationValue: OptionActiveSituation = 'ENABLED';

    constructor(
        protected service: RegistrationEmployeeRoleService,
        protected baseService: GIPIBaseService,
        protected activatedRoute: ActivatedRoute,
        public dialogRef: MatDialogRef<EmployeeRolesFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EmployeeRolesFormData = { typeOperation: 'NEW', employeeRole: null },
    ) {
        super(baseService, activatedRoute);
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {
        super.ngOnInit();
        this.typeOperation = this.data.typeOperation;
        if (this.typeOperation !== 'NEW') {
            this.employeeRole = this.data.employeeRole;

            if (!this.employeeRole.enabled) {
                this.optionActiveSituationValue = 'DISABLED';
            }
        }
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public confirm(): void {
        try {
            if (ObjectUtil.isNull(this.employeeRole)) {
                return;
            }
            if (StringUtil.isEmpty(this.employeeRole.description)) {
                this.addWarningMessage('Campo descrição é obrigatório e não foi informado');
                return;
            }
            if (this.employeeRole.description.length < 5) {
                this.addWarningMessage('Campo descrição deve conter no mínimo 5 caracteres');
                return;
            }
            this.loading = true;

            this.employeeRole.enabled = (this.optionActiveSituationValue === 'ENABLED');

            this.service.save(this.employeeRole).toPromise().then(() => {
                this.addSuccessMessage(INJECTOR.get(APP_MESSAGES).SUCCESS);
                this.loading = false;
                this.close('RELOAD_TABLE');
            }, error => {
                throw new Error(error);
            });
        } catch (e) {
            this.loading = false;
            this.handleError(e);
        }
    }

    /**
     * @template RELOAD_TABLE Dá reload na grid atualizando os registros
     * @template REMARK_SELECTED Volta a tela anterior e seleciona os registros na grid
     * @template NONE Não acontece nada, só volta para tela anterior
     */
    public close(operation: 'RELOAD_TABLE' | 'REMARK_SELECTED' | 'NONE'): void {
        this.dialogRef.close(operation);
    }

}
